// extracted by mini-css-extract-plugin
export default {"melodyVideo":"WL-z","isFullWidth":"XL-z","landingPageVideo":"YL-z","play":"ZL-z","iframeVideo":"_L-z","playHidden":"aM-z","fullwidth":"bM-z"};